import * as React from "react";
import { BuilderContext, useDrawer } from "react-flow-builder";
import { useForm, useFieldArray, useWatch } from "react-hook-form";
import { Text, Grid, Button, Modal, ActionIcon, Title, Divider } from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons-react";

import { CTextInput, CSelect, CMultiSelect, CCheckbox, CRadioGroup } from "@supportinitiative/react-hook-form-mantine";

import { ReconsetCVMContext } from "../../ReconsetCVM";
import { getLinkagesLOV, operators, getSystemStatus, getConfirmationStatus } from "../../ReconsetUtils";
import Query from "./Query";
import { object, string, number, date, array, setLocale } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { AnchorMatchActionType, AnchorMatchActionSchema } from "@supportinitiative/common";

function AnchorQueryMatch() {
  const { selectedNode: node } = React.useContext(BuilderContext);
  const { closeDrawer: cancel, saveDrawer: save } = useDrawer();
  const { state: reconsetFormState } = React.useContext(ReconsetCVMContext);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm<AnchorMatchActionType>({
    defaultValues: node?.data || {
      name: "",
      statusOverride: "IGNORE",
    },
    criteriaMode: "all",
    resolver: yupResolver(AnchorMatchActionSchema),
  });

  const type = useWatch({
    control,
    name: "type",
  });

  const anchorConditions = useFieldArray({
    control,
    name: "anchorConditions",
  });

  const matchConditions = useFieldArray({
    control,
    name: "matchConditions",
  });

  const recon = reconsetFormState.recon;
  return (
    <Modal centered size={"xl"} opened={true} onClose={cancel} title={<Title order={4}>Anchor Match</Title>}>
      <Grid align="stretch" gutter={"xs"} mb="xs">
        <Grid.Col span={12}>
          <CTextInput
            name={`name`}
            control={control}
            showErrorText={false}
            label="Name"
            required
            disabled={node?.disabled || false}
          />
        </Grid.Col>
      </Grid>

      <Grid align="stretch" gutter={"xs"} mb="xs">
        <Grid.Col span={12}>
          <CSelect
            name={`type`}
            control={control}
            data={[
              { label: "Within Primary", value: "WITHIN-PRIMARY" },
              { label: "Within Secondary", value: "WITHIN-SECONDARY" },
              {
                label: "Primary against Primary",
                value: "PRIMARY-AGAINST-PRIMARY",
              },
              {
                label: "Seconday against Secondary",
                value: "SECONDARY-AGAINST-SECONDARY",
              },
              {
                label: "Primary against Secondary",
                value: "PRIMARY-AGAINST-SECONDARY",
              },
              {
                label: "Seconday against Primary",
                value: "SECONDARY-AGAINST-PRIMARY",
              },
            ]}
            showErrorText={false}
            label="Type"
            searchable
            clearable
            required
            disabled={node?.disabled || false}
          />
        </Grid.Col>
      </Grid>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // borderTop: "2px solid #ccc",
          // paddingTop: "20px",
        }}
      >
        <Divider my="xs" label="Query" labelPosition="center" />
        <Grid align="stretch" gutter={"xs"} mb="xs">
          <Grid.Col span={12}>
            <Query
              name={`left`}
              control={control}
              label="Query - Left"
              type={
                type === "PRIMARY-AGAINST-PRIMARY" || type === "PRIMARY-AGAINST-SECONDARY" || type === "WITHIN-PRIMARY"
                  ? "PRIMARY"
                  : "SECONDARY"
              }
              recon={recon}
            />
          </Grid.Col>
        </Grid>

        {type !== "WITHIN-PRIMARY" && type !== "WITHIN-SECONDARY" ? (
          <Grid align="stretch" gutter={"xs"} mb="xs">
            <Grid.Col span={12}>
              <Query
                name={`right`}
                control={control}
                label="Query - Right"
                type={
                  type === "PRIMARY-AGAINST-PRIMARY" || type === "SECONDARY-AGAINST-PRIMARY" ? "PRIMARY" : "SECONDARY"
                }
                recon={recon}
              />
            </Grid.Col>
          </Grid>
        ) : (
          <></>
        )}
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // borderTop: "2px solid #ccc",
          // paddingTop: "20px",
          // width: "90%",
        }}
      >
        <Divider my="xs" label="Anchor" labelPosition="center" />

        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Text fw={500} style={{ fontSize: "14px" }}>
            Anchor Conditions
          </Text>
          <ActionIcon
            size="sm"
            variant="white"
            color="gray"
            onClick={() => {
              anchorConditions.append({
                left: "",
                operator: "=",
                right: "",
              });
            }}
            disabled={node?.disabled || false}
          >
            <IconPlus />
          </ActionIcon>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "20px",
            marginLeft: "20px",
            width: "90%",
          }}
        >
          {anchorConditions.fields.map((field, index) => {
            return (
              <Grid align="stretch" gutter={"xs"} mb="xs" key={field.id}>
                <Grid.Col span={4}>
                  <CTextInput
                    name={`anchorConditions.${index}.left`}
                    control={control}
                    label={index === 0 ? "Left" : ""}
                    disabled={node?.disabled || false}
                  />
                </Grid.Col>
                <Grid.Col span={3}>
                  <CSelect
                    name={`anchorConditions.${index}.operator`}
                    control={control}
                    searchable
                    data={[
                      {
                        value: "=",
                        label: "=",
                      },
                    ]}
                    label={index === 0 ? "Operator" : ""}
                    disabled={node?.disabled || false}
                  />
                </Grid.Col>
                <Grid.Col span={4}>
                  <CTextInput
                    name={`anchorConditions.${index}.right`}
                    control={control}
                    label={index === 0 ? "Right" : ""}
                    disabled={node?.disabled || false}
                  />
                </Grid.Col>
                <Grid.Col span={1} style={{ display: "flex", alignItems: "flex-end" }}>
                  <ActionIcon
                    size="sm"
                    variant="white"
                    color="gray"
                    onClick={() => {
                      anchorConditions.remove(index);
                    }}
                    disabled={node?.disabled || false}
                  >
                    <IconTrash />
                  </ActionIcon>
                </Grid.Col>
              </Grid>
            );
          })}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // borderTop: "2px solid #ccc",
          // paddingTop: "20px",
          // width: "90%",
        }}
      >
        <Divider my="xs" label="Match" labelPosition="center" />

        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Text fw={500} style={{ fontSize: "14px" }}>
            Match Conditions
          </Text>
          <ActionIcon
            size="sm"
            variant="white"
            color="gray"
            onClick={() => {
              matchConditions.append({
                left: "",
                operator: "=",
                right: "",
              });
            }}
            disabled={node?.disabled || false}
          >
            <IconPlus />
          </ActionIcon>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "20px",
            marginLeft: "20px",
            width: "90%",
          }}
        >
          {matchConditions.fields.map((field, index) => {
            return (
              <Grid align="stretch" gutter={"xs"} mb="xs" key={field.id}>
                <Grid.Col span={4}>
                  <CTextInput
                    name={`matchConditions.${index}.left`}
                    control={control}
                    label={index === 0 ? "Left" : ""}
                    disabled={node?.disabled || false}
                  />
                </Grid.Col>
                <Grid.Col span={3}>
                  <CSelect
                    name={`matchConditions.${index}.operator`}
                    control={control}
                    searchable
                    data={operators}
                    label={index === 0 ? "Operator" : ""}
                    disabled={node?.disabled || false}
                  />
                </Grid.Col>
                <Grid.Col span={4}>
                  <CTextInput
                    name={`matchConditions.${index}.right`}
                    control={control}
                    label={index === 0 ? "Right" : ""}
                    disabled={node?.disabled || false}
                  />
                </Grid.Col>
                <Grid.Col span={1} style={{ display: "flex", alignItems: "flex-end" }}>
                  <ActionIcon
                    size="sm"
                    variant="white"
                    color="gray"
                    onClick={() => {
                      matchConditions.remove(index);
                    }}
                    disabled={node?.disabled || false}
                  >
                    <IconTrash />
                  </ActionIcon>
                </Grid.Col>
              </Grid>
            );
          })}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // borderTop: "2px solid #ccc",
          // paddingTop: "20px",
          // width: "90%",
        }}
      >
        <Divider my="xs" label="Status" labelPosition="center" />

        <Grid align="stretch" gutter={"xs"} mb="xs">
          <Grid.Col span={4}>
            <CSelect
              name={`systemStatus`}
              control={control}
              label="Status"
              data={getSystemStatus("ALL")}
              showErrorText={false}
              searchable
              required
              disabled={node?.disabled || false}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <CSelect
              name={`confirmationStatus`}
              control={control}
              label="Confirmation Status"
              data={getConfirmationStatus()}
              showErrorText={false}
              searchable
              required
              disabled={node?.disabled || false}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <CMultiSelect
              name={`userStatus`}
              control={control}
              label="User Status"
              searchable
              data={reconsetFormState.userStatus || []}
              showErrorText={false}
              disabled={node?.disabled || false}
            />
          </Grid.Col>
        </Grid>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // borderTop: "2px solid #ccc",
          // paddingTop: "20px",
          // width: "90%",
        }}
      >
        <Divider my="xs" label="Status Override" labelPosition="center" />

        <Grid align="stretch" gutter={"xs"} mb="xs">
          <Grid.Col span={12}>
            <CRadioGroup
              name={`statusOverride`}
              control={control}
              data={[
                { label: "Ignore", value: "IGNORE" },
                /* { label: "Override", value: "OVERRIDE" }, */
                { label: "Append", value: "APPEND" },
              ]}
              disabled={node?.disabled || false}
            />
          </Grid.Col>
        </Grid>
      </div>

      <Grid align="stretch" gutter={"xs"} mt="xs">
        <Grid.Col span={2}>
          <Button
            color="teal"
            variant="filled"
            fullWidth
            type="submit"
            onClick={
              node?.disabled
                ? () => {
                    console.log("only cancel");
                    cancel();
                  }
                : async (event: React.MouseEvent<HTMLButtonElement>) => {
                    event.preventDefault();
                    const values = getValues();
                    // console.log("values", values);
                    clearErrors();
                    try {
                      await AnchorMatchActionSchema.validate(values, {
                        abortEarly: false,
                      });

                      save?.(values);
                      //cancel();
                    } catch (error) {
                      console.log("errors", error);
                      console.log("error inner", JSON.stringify(error));
                      (error as any).inner.forEach((err: any) => {
                        setError(err.path, {
                          type: "custom",
                          message: err.message,
                        });
                      });
                    }
                  }
            }
          >
            Ok
          </Button>
        </Grid.Col>
      </Grid>
    </Modal>
  );
}

export default AnchorQueryMatch;
